import { ScopeButton } from '@monorepo/shared-lib';
import { Form, Typography } from 'antd';
import { ScopeCheckbox } from 'components/Custom/checkbox';
import { FormInput, FormTextArea } from 'components/Custom/inputs';
import { LabelWrapper } from 'components/Custom/labels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnDrawerOff } from 'store/app/actions';
import { EmailDataParametersRequest } from 'store/vat/models/emailDataParametersRequest';

const { Text } = Typography;
interface ClientApproveFormProps {
  sendForClientApproval: (values: EmailDataParametersRequest) => void;
}

export const ClientApproveForm: React.FC<ClientApproveFormProps> = ({
  sendForClientApproval,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = (values: any) => {
    const formValues = {
      ...values,
    } as EmailDataParametersRequest;

    sendForClientApproval(formValues);
    dispatch(turnDrawerOff());
  };

  return (
    <>
      <Text
        style={{
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '22px',
          textAlign: 'left',
          color: 'var(--color-text-muted, #5a6a6a)',
          marginBottom: '40px',
        }}
      >
        {t('vat-report.add-any-notes-email-sent-to-client-for-approval')}
      </Text>
      <Form
        style={{
          marginTop: '40px',
        }}
        layout="horizontal"
        key={Date()}
        onFinish={handleSubmit}
        //style={{ marginBottom: '30px' }}
        //form={form}
      >
        <LabelWrapper>
          <span
            className="label-text"
            style={{ fontSize: 14, fontWeight: 400 }}
          >
            {t('common.subject')}
          </span>
        </LabelWrapper>
        <Form.Item
          name="emailSubject"
          rules={[{ required: true, message: t('common.required-field') }]}
        >
          <FormInput
            width={'100%'} //@ts-ignore
            border_color="var(--color-border, #dbeae3)"
          />
        </Form.Item>
        <LabelWrapper>
          <span
            className="label-text"
            style={{ fontSize: 14, fontWeight: 400 }}
          >
            {t('common.note')}
          </span>
        </LabelWrapper>
        <Form.Item
          name="emailMessage"
          rules={[{ required: true, message: t('common.required-field') }]}
        >
          <FormTextArea
            rows={5}
              placeholder={t('vat-report.add-note-to-client-here')}
          />
        </Form.Item>
        <Form.Item
          style={{ marginBottom: '0px' }}
          initialValue={true}
          valuePropName="checked"
          name="isPreparerIncluded"
        >
          <ScopeCheckbox
            style={{
              fontSize: '12px',
              fontWeight: '400',
            }}
            defaultChecked
          >
            {t('vat-report.send-copy-to-preparer')}
          </ScopeCheckbox>
        </Form.Item>
        <Form.Item
          initialValue={true}
          valuePropName="checked"
          name="isReviewerIncluded"
        >
          <ScopeCheckbox
            style={{
              fontSize: '12px',
              fontWeight: '400',
            }}
            defaultChecked
          >
            {t('vat-report.send-copy-to-reviewer')}
          </ScopeCheckbox>
        </Form.Item>
        <Form.Item>
          <ScopeButton //@ts-ignore
            width="100%"
            height="40px"
            type="primary"
            htmlType="submit"
          >
            {t('common.send-to-client')}
          </ScopeButton>
          <div style={{ marginTop: '20px' }}>
            <ScopeButton //@ts-ignore
              width="100%"
              height="40px"
              bg_color="var(--color-layout-bg, #E9F6F7)"
              type={'default'}
              onClick={() => dispatch(turnDrawerOff())}
            >
              {t('common.cancel')}
            </ScopeButton>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};
